import { useQuery } from "@apollo/client";
import { CasesCredentailVerificationV1CaseHistoryContainerCredentailVerificationCaseV1Document } from "../../../../../../generated";
import { CaseHistory } from "./case-history";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";

export interface CaseHistoryContainerProps {
  caseId: string;
  isCaseOrApplicant: string;
}

export const CaseHistoryContainer: React.FC<CaseHistoryContainerProps> = (
  props
) => {
  const {
    data: caseData,
    loading: caseLoading,
    error: caseError,
  } = useQuery(
    CasesCredentailVerificationV1CaseHistoryContainerCredentailVerificationCaseV1Document,
    {
      variables: {
        credentialVerificationCaseV1Id: props.caseId,
      },
    }
  );


  return (
    <ComponentQueryLoader
      loading={caseLoading}
      error={caseError}
      hasData={caseData}
      hasDataComponent={
        <CaseHistory
          data={caseData?.credentialVerificationCaseV1}
          isCaseOrApplicant={props.isCaseOrApplicant}
        />
      }
    />
  );
};
